import { Dayjs } from "dayjs";
import { DoorState } from "../enums/DoorState";

export type ScheduleSlot = {
    
    actualTime: Dayjs;
    canAddRow: boolean;
    canEditTime: boolean;
    canRemoveRow: boolean;
    doorState: DoorState;
    minTime: Dayjs;
    slotId: string;
    
};

export const MINUTES_STEP = 10;